import React, { useEffect } from "react";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
// import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

const doSubmit = () => {
	let user_captcha_value = document.getElementById('user_captcha_input').value;

	if (validateCaptcha(user_captcha_value, false) === true) {
		alert('Captcha Matched');
	}

	else {
		alert('Captcha Does Not Match');
	}
}

const Captcha = () => {

	useEffect(() => {
		loadCaptchaEnginge(4);
	}, []); // EMPTY ARRAY  
	return (
		<div className="container">
			<br />
			
			<div className="container">
				<h4>Captcha Sample</h4> 
			</div>

			<div className="form-group">
				<div className="col-sm-12 col-md-12">
					<LoadCanvasTemplate />
				</div>

				<div className="col-sm-12 col-md-12">
					<div><input placeholder="Enter Captcha Value" id="user_captcha_input" name="user_captcha_input" type="text"></input></div>
				</div>
				<div className="col mt-3">
					<div><button class="btn btn-primary" onClick={doSubmit}>Submit</button></div>
				</div>
			</div>

		</div>
	);
};

export default Captcha;